import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'lib-instrument-field-add',
  imports: [TranslatePipe],
  templateUrl: './instrument-field-add.component.html',
  styleUrl: './instrument-field-add.component.scss',
})
export class InstrumentFieldAddComponent {

}
